/**
 * Administrator: who holds the back-office's privileges, and who holds the
 * Administrator role. Two questions since task #648.
 *
 * Every staff account (`is_admin`) has an Administrator's rights for now
 * (inviting, editing or deactivating an administrator, editing, deactivating or
 * deleting a licence, naming its main contacts, managing API keys), so
 * `hasAdministratorRights` decides what to OFFER. `isAdministrator` still reads
 * `admin_role` and decides who is PROTECTED: an Administrator cannot be
 * deactivated or deleted.
 *
 * Pure and structurally typed on the single field each needs, so they take the
 * auth user, a loaded `UserResponse`, or a hand-built actor. They mirror (and
 * are the counterparts of) `backend/src/domain/administrator.ts`.
 *
 * Exact match, not case-insensitive like the backend's: the frontend only ever
 * reads values the API produced from `ADMIN_ROLES`, and `canArchive` has always
 * compared exactly. The backend is the authority either way; this decides what
 * to draw, never what to allow.
 */
export interface AdminRoleHolder {
  admin_role: string | null;
}

export interface StaffHolder {
  is_admin: boolean;
}

export const ADMINISTRATOR_ROLE = 'Administrator';

export function isAdministrator(actor: AdminRoleHolder | null | undefined): boolean {
  return actor?.admin_role === ADMINISTRATOR_ROLE;
}

/** Every staff account, whatever its `admin_role` (#648). */
export function hasAdministratorRights(actor: StaffHolder | null | undefined): boolean {
  return actor?.is_admin === true;
}
